import { ChevronDown } from "lucide-react";
import { AccordionInterface } from "../../interfaces/AccordionInterface";
import {
  AccordionContent,
  AccordionHeader,
  AccordionWrapper,
  ArrowIcon,
} from "./AccordionStyles";

export const Accordion = ({
  title,
  children,
  isOpen,
  onToggle,
}: AccordionInterface) => {
  const contentId = `accordion-content-${title
    .replace(/\s+/g, "-")
    .toLowerCase()}`;

  return (
    <AccordionWrapper>
      <AccordionHeader
        onClick={onToggle}
        aria-expanded={isOpen}
        aria-controls={contentId}
      >
        {title}
        <ArrowIcon animate={{ rotate: isOpen ? 180 : 0 }}>
          <ChevronDown size={20} />
        </ArrowIcon>
      </AccordionHeader>

      <AccordionContent
        id={contentId}
        role="region"
        initial="collapsed"
        animate={isOpen ? "expanded" : "collapsed"}
        variants={{
          expanded: { height: "auto", opacity: 1 },
          collapsed: { height: 0, opacity: 0 },
        }}
        transition={{ duration: 0.4, ease: "easeInOut" }}
      >
        <div style={{ padding: "12px 0" }}>{children}</div>
      </AccordionContent>
    </AccordionWrapper>
  );
};
